import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDashboards,
  fetchDashboardById,
  saveDashboard,
  updateDashboard,
  deleteDashboard,
} from "../actions/dashsActions";

const initialState = {
  dashs: [],
  currentDashboard: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // FETCH ALL
      .addCase(fetchDashboards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboards.fulfilled, (state, action) => {
        state.loading = false;
        state.dashs = action.payload.data ?? action.payload;
      })
      .addCase(fetchDashboards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // FETCH BY ID
      .addCase(fetchDashboardById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentDashboard = null;
      })
      .addCase(fetchDashboardById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentDashboard = action.payload;

        const index = state.dashs.findIndex(d => d.id === action.payload.id);
        if (index !== -1) {
          state.dashs[index] = action.payload;
        }
      })
      .addCase(fetchDashboardById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.currentDashboard = null;
      })

      // SAVE
      .addCase(saveDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveDashboard.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.dashs.findIndex(d => d.id === action.payload.id);
        if (index !== -1) {
          state.dashs[index] = action.payload;
        } else {
          state.dashs.push(action.payload);
        }
      })
      .addCase(saveDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDashboard.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.dashs.findIndex(d => d.id === action.payload.id);
        if (index !== -1) {
          state.dashs[index] = action.payload;
        }
        if (state.currentDashboard && state.currentDashboard.id === action.payload.id) {
          state.currentDashboard = action.payload;
        }
      })
      .addCase(updateDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteDashboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDashboard.fulfilled, (state, action) => {
        state.loading = false;
        state.dashs = state.dashs.filter(d => d.id !== action.payload);
        if (state.currentDashboard && state.currentDashboard.id === action.payload) {
          state.currentDashboard = null;
        }
      })
      .addCase(deleteDashboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardSlice.reducer;
